import React, { useEffect, useState } from "react";
import { Link  } from "react-router-dom";
import axios from "axios";
import { useContentObjectContext } from "../contexts/ContentObjectContext";
import { globalConfig } from "../../../config/config";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
// const querystring = require("querystring");

const CreateContentAnnotation = () => {
  const { currentContentObject } = useContentObjectContext();
  const [message, setMessage] = useState("");

  const {token,userMetadata}=useAuth()
  const history = useHistory();
  const [state, setState] = useState({
    contentAnnotationId: 0,
    contentId: currentContentObject,
    annotationName: "",
    annotation: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-annotations`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-annotations/contentAnnotationId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentAnnotationId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentAnnotationId
          );
          // && response2.data.contentFacadeId === state.contentFacadeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      console.log("message info - " + message);
      setState({ ...state, annotationName: "", annotation: "" });
    });
  }
  function handleRest() {
    setState({ ...state, annotationName: "", annotation: "" });
  }

  useEffect(() => {
    handleOnLoad();
  }, []);

  const handleOnLoad = () => {
    // axios
    //   .get(`<http://os-dev.origosoftware.com:3000/CreateContentAnnotation/`)
    //   .then((res) => {
    //     const connectors = res.data;
    //     console.log(connectors);
    //     setState({ connectors });
    //     console.log(res.data[0]);
    //   });
  };

  return (
    <form>
      <div className="container-fluid">
        <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
        <h4>Create Content Annotation</h4>
        <hr />
        <div className="container-fluid">
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Annotation Name">
              Annotation Name
            </label>
            <input
              id="annotationName"
              className="form-control input-xlarge col-sm-8"
              value={state.annotationName}
              onChange={handleChange}
            />
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Annotation">
              Annotation
            </label>
            <input
              id="annotation"
              className="form-control input-xlarge col-sm-8"
              value={state.annotation}
              onChange={handleChange}
            />
          </div>
          <hr />
          <button
            className="btn btn-primary"
            value="Clear"
            onCLick={handleRest}
          >
            {" "}
            Clear
          </button>
          &nbsp;
          <button
            className="btn btn-success"
            value="Create"
            onClick={handleSubmit}
          >
            {" "}
            Create
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateContentAnnotation;
